import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CargandoService } from './cargando.service';

@Component({
  selector: 'app-cargando',
  templateUrl: './cargando.component.html',
  styleUrls: ['./cargando.component.css']
})
export class CargandoComponent implements OnInit {
  isLoading : boolean = false;

  backToHome() {
    this.isLoading = false;
  //this.router.navigateByUrl('/');
  }

  constructor(private loadingService : CargandoService, private router : Router) { }

  ngOnInit() {

    this.loadingService.isLoading.subscribe(isLoading => {
      this.isLoading = isLoading;
    })
  }

}
